import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  state: {
    mobileMenuStatus: false,
    homeSlider: false,
    loadedPage: '',
    scrolltoElement: null,
    previousProject: '',
    nextProject: '',
    translationProject: '',
    atelierShown: false,
    teamShown: false,
  },
  mutations: {
    homeSlider(state, payload) {
      this.state.homeSlider = payload;
    },
    loadedPage(state, payload) {
      this.state.loadedPage = payload;
    },
    switchLanguage(state, payload) {
      this.state.i18n.locale = payload;
    },
    scrolltoElement(state, payload) {
      this.state.scrolltoElement = payload;
    },
    menuToggle(state, payload) {
      if (payload === 'close') {
        this.state.mobileMenuStatus = false;
      } else if (payload === 'open') {
        this.state.mobileMenuStatus = true;
      } else {
        this.state.mobileMenuStatus = !this.state.mobileMenuStatus;
      }
    },
    setPreviousProject(state, payload) {
      this.state.previousProject = payload;
    },
    setNextProject(state, payload) {
      this.state.nextProject = payload;
    },
    setTranslationProject(state, payload) {
      this.state.translationProject = payload;
    },
    showAtelier(state, payload) {
      this.state.atelierShown = payload;
    },
    showTeam(state, payload) {
      this.state.teamShown = payload;
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/store.js